import styled from 'styled-components';
import { ImageButtonStyled } from '../ImageButtonStyled';
import { rem } from 'polished';

export const ImageButtonStyledAC = styled(ImageButtonStyled)`
    .img-btn-container {
        border: none;
        color: ${({ theme }) => theme.colors.black};
        text-decoration: none;

        img {
            display: block;
            object-fit: contain;
            max-height: ${rem('240px')};
            padding: unset;
        }

        h1 {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        }

        .description {
            display: none;
        }

        &.inactive {
            background-color: ${({ theme }) => theme.colors.grey7};
        }

        &.active {
            background-color: ${({ theme }) => theme.colors.white};

            &:hover {
                box-shadow: none;
                cursor: pointer;
                opacity: 0.8;
            }
            .description {
                :after {
                    visibility: visible;
                }
            }
        }

        .sum {
            background-color: ${({ theme }) => theme.colors.blue2};
            font-size: ${({ theme }) => theme.fontSizes.h6} !important;
            width: ${rem('16px')} !important;
            height: ${rem('16px')} !important;
        }
    }

    .top {
        h1 {
            font-weight: bold;
            font-size: ${rem(22)};
            font-family: ${({ theme }) => theme.fonts.fontBase};
            color: ${({ theme }) => theme.colors.grey5};
            text-transform: inherit !important;
        }
    }
`;
